 /**
    * Formats a given time duration (in seconds) into a human-readable string.
    * The result displays the total number of hours and optionally provides a breakdown in days, hours, and minutes 
    * if number of hours are greater than 24.
    * 
    * @param {number} seconds - The total duration in seconds to be formatted.
    * @param {object} locale - An object responsible for providing localized translations
    * @returns {string} A formatted string representing the duration in hours, days, and minutes.
    * Example input 1 : 1238129 seconds
    * Total hours : 343 hours, Days : 14, hours : 7, minutes : 55
    * Output : "343 hours (14 days, 7 hours, 55 minutes)"
    * Example input 2 : 7200 seconds
    * Output : "2 hours"
*/
 
export const generatorRunTimeFormatter = (seconds , locale) => {
    const DAY_IN_SECONDS = 24 * 3600;
    const HOUR_IN_SECONDS = 3600;

    // Calculate total days, hours, minutes
    const days = Math.floor(seconds / DAY_IN_SECONDS);
    seconds %= DAY_IN_SECONDS; 
    const hours = Math.floor(seconds / HOUR_IN_SECONDS);
    seconds %= HOUR_IN_SECONDS;
    const minutes = Math.floor(seconds / 60);
    const totalHours = days * 24 + hours;

    // Return the value with translation and pluralization
    const getTimeString = (total, type = "hour") => {
        const single = `dashboard.${type}`;
        const multiple = `dashboard.${type}s`;
        return `${total} ${locale.getString(total === 1 ? single : multiple)}`;
    };
    
    let timeString = totalHours>0 ?  getTimeString(totalHours) : '';

    if (totalHours >= 24) {
        if (days > 0) timeString += `, ${days} ${locale.getString(days === 1 ? 'common.day' : 'common.days')}`;
        if (hours > 0) timeString += `, ${getTimeString(hours, 'hour')}`;
        if (minutes > 0) timeString += `, ${getTimeString(minutes, 'minute')}`;
        timeString = timeString.replace(/, /, ' (') + ')'; // Replace first comma with ' (' and close with ')'
    } else {
        if (minutes > 0) timeString += (hours > 0 ? `, ` : ``) + getTimeString(minutes, 'minute'); //If hours are shown, add a comma
    }
    
    return timeString;
};
